export default "__VITE_ASSET__DpG6jqZ2__"